import ScrollManager from './scroll.js';
import common from './common.js';
import figurePosition from './figureposition.js';
import panzoom from './panzoom.js';
import modal from './modal.js';
import acod from './acod.js';
import movie from './movie.js';
import tab from './tab.js';
import panorama from './panorama.js';
import slider from './slider.js';
import Top from '../../../js/_function.js';
import Login from '../../../limited/js/_function.js';
import parallax from './parallax.js';
import pageScroll from './pagescroll.js';
import contentMenu from './contentmenu.js';
// // eslint-disable-next-line

document.addEventListener(
  'DOMContentLoaded',
  () => {
    new ScrollManager();
    new common();
    new figurePosition();
    new movie();
    new modal();
    new acod();
    new tab();
    new panorama();
    new panzoom();
    new slider();
    new parallax();
    new pageScroll();
    new contentMenu();

    const $pageId = document.getElementsByClassName('currentPage')[0];
    switch ($pageId.getAttribute('id')) {
      case 'top':
        new Top();
        break;
      case 'login':
        // 資料請求者様限定サイトのパス照合。限定ページ側のガードは
        // 描画前に走らせる必要があるため lib.js ではなく _guard.ejs が持つ
        new Login();
        break;
      default:
    }
  },
  false
);
